import { authService } from '../_services/auth.service'
import { userService } from '../_services/user.service'
import AppConstants from '../constants/app.constants'

const isSystemSessionStorageLogin = sessionStorage.getItem(AppConstants.STORAGE_LOGIN_MODE) === AppConstants.SYSTEM_LOGIN_MODE
const storedToken = sessionStorage.getItem(AppConstants.TOKEN) || localStorage.getItem(AppConstants.TOKEN)
const user = JSON.parse(sessionStorage.getItem('plusa-user')) || JSON.parse(localStorage.getItem('plusa-user'))
const state = storedToken
  ? { status: { loggedIn: true }, user, isSystemSessionStorageLogin }
  : { status: { loggedIn: false }, user: {}, isSystemSessionStorageLogin: false }

const actions = {
  async login({ dispatch, commit }, { username, password, isRememberMe }) {
    commit('loginRequest', { username })

    const loginErrorMsg = await authService
      .login(username, password, isRememberMe)
      .catch(error => {
        commit('loginFailure', error)
        // dispatch('alert/error', error, { root: true })
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
        return Promise.reject(message)
      })

    if (loginErrorMsg) {
      commit('loginFailure', loginErrorMsg)
      // dispatch('alert/error', loginErrorMsg, { root: true })
      return Promise.reject(loginErrorMsg)
    }
    commit('updateIsSystemSessionStorageLogin', !isRememberMe)
    // Update User Info when successfull login
    let updateUser = {}
    if (isRememberMe) {
      updateUser = JSON.parse(localStorage.getItem('plusa-user'))
    } else {
      updateUser = JSON.parse(sessionStorage.getItem('plusa-user'))
    }
    commit('loginSuccess', updateUser)
    return Promise.resolve(true)
  },

  async logout({ commit }) {
    await authService.logout()
    await commit('logout')
  },
  // CONFIRM CODE FROM EMAIL
  async confirmCodeFromEmail({ dispatch, commit }, { confirmCode, email }) {
    const data = await userService
      .postConfirmVerifyCode(confirmCode, email)
      .catch(error => {
        commit('loginFailure', error)
        return Promise.reject(error)
      })

    if (data.token) {
      localStorage.setItem(AppConstants.TOKEN, data.token)
      const userDetails = await userService.getUserInfo()
      if (userDetails) {
        localStorage.setItem(
          AppConstants.USER_DETAILS,
          JSON.stringify(userDetails)
        )
      }
      // Update User Info when successfull login
      const updateUser = JSON.parse(localStorage.getItem('plusa-user'))
      commit('loginSuccess', updateUser)
      return Promise.resolve(true)
    }
  },

  // UPDATE USER INFO
  async updateUserInfo({ commit }, { nickName, email }) {
    // Update Email and nickName
    const updateUserResponse = await userService.updateUserInfo(email, nickName)
    if (updateUserResponse) {
      const userResponse = await userService.getUserInfo()
      if (userResponse) {
        commit('storageUserDetails', userResponse)
        commit('loginSuccess', userResponse)
      }
    }

    return Promise.resolve(true)
  },

  // UPDATE AVATAR
  async updateAvatar({ commit }, { avatar }) {
    const updateUserResponse = await userService.updateAvatar(avatar)
    if (updateUserResponse) {
      const userResponse = await userService.getUserInfo()
      if (userResponse) {
        commit('storageUserDetails', userResponse)
        commit('loginSuccess', userResponse)
      }
    }
    return Promise.resolve(true)
  },

  // UPDATE NICKNAME
  async updateNickname({ dispatch, commit }, { nickName }) {
    await userService.updateUserNickname(nickName)
    const userResponse = await userService.getUserInfo()
    if (userResponse) {
      commit('storageUserDetails', userResponse)
      commit('loginSuccess', userResponse)
    }
    return Promise.resolve(true)
  },

  /**
   * Entraログインを検証する非同期関数。
   * @param {Object} context - Vuexのコンテキストオブジェクト
   * @param {Object} payload - アクセストークンとテナントIDを含むペイロード
   * @param {string} payload.accessToken - Entraからのアクセストークン
   * @param {string} payload.tenantId - EntraのテナントID
   * @returns {Promise<boolean>} 成功した場合はtrue、失敗した場合はエラーメッセージを返す
   */
  async verifyEntraLogin({ commit }, { accessToken, tenantId }) {
    const loginErrorMsg = await authService
      .verifyEntraLogin(accessToken, tenantId)
      .catch(error => {
        commit('loginFailure', error)
        return Promise.reject(error)
      })

    if (loginErrorMsg) {
      commit('loginFailure', loginErrorMsg)
      return Promise.reject(loginErrorMsg)
    }

    // ログイン成功時にユーザー情報を更新
    const updateUser = JSON.parse(localStorage.getItem(AppConstants.USER_DETAILS))
    commit('loginSuccess', updateUser)
    return Promise.resolve(true)
  }
}

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true }
    state.user = user
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true }
    state.user = user
  },
  loginFailure(state) {
    state.status = {}
    state.user = ''
  },
  logout(state) {
    state.status = {}
    state.user = ''
    state.isSystemSessionStorageLogin = false
  },
  /**
   * システムセッションストレージログインフラグを更新するミューテーション。
   * @param state - Vuexの状態オブジェクト
   * @param isSystemSessionStorageLogin - 更新するフラグの値
   */
  updateIsSystemSessionStorageLogin(state, isSystemSessionStorageLogin) {
    state.isSystemSessionStorageLogin = isSystemSessionStorageLogin
  },
  /**
   * ユーザー情報をストレージに保存する非同期関数。
   * @param state - Vuexの状態オブジェクト
   * @param userDetails - 保存するユーザー情報
   */
  storageUserDetails(state, userDetails) {
    if (state.isSystemSessionStorageLogin) {
      sessionStorage.setItem(
        AppConstants.USER_DETAILS,
        JSON.stringify(userDetails)
      )
    } else {
      localStorage.setItem(
        AppConstants.USER_DETAILS,
        JSON.stringify(userDetails)
      )
    }
  }
}
// GETTERS
const getters = {
  getUserDetails() {
    return state.user
  },
  getNickName() {
    return state.user.nickName
  },
  getUserAvatar() {
    return state.user ? state.user.avatar : ''
  },
  getIsSystemSessionStorageLogin() {
    return state.isSystemSessionStorageLogin
  }
}

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/auth.module.js